import { render } from "./SiteMenu.vue?vue&type=template&id=752fdf73&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import "./SiteMenu.vue?vue&type=style&index=0&id=752fdf73&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752fdf73"]])

export default __exports__